import { call, cancel, fork, put, race, take } from 'redux-saga/effects';
import { fetchRunDataFailure, fetchRunDataSuccess } from '../actions';
import { ApiError } from 'store/api/types';
import { FetchRunDataRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import {
  CheckEntityStatusResponse,
  GetRunDataResponse,
  checkEntityStatus,
  getRunData,
} from '../api';
import { turnMessageOn, updateMappingData } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { DataStatus, VatRunData } from '../models';
import { logoutRequest } from 'store/auth/actions';
import { push } from 'store/navigation/actions';
import routes from 'routes';
import { renderErrorMessage } from 'utils/render-error-message';
import { buildGroupReturnContextSearch } from 'utils/group-return-context';
import { CANCEL_VAT_SAGA, FETCH_RUN_DATA_REQUEST } from '../constants';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchRunDataSaga(action: FetchRunDataRequestAction) {
  try {
    let err: ApiError | null;
    const { vatRunRequestData, groupContext, navigateToReport = true, reportRoute } =
      action.payload;

    const statusCheckResponse: CheckEntityStatusResponse = yield call(
      checkEntityStatus,
      vatRunRequestData.connectionId
    );

    //if (statusCheckResponse.data.status === DataStatus.IN_PROGRESS) {
    if (
      statusCheckResponse.data.status !== DataStatus.IDLE &&
      statusCheckResponse.data.status !== null // TODO: remove this once we have a proper way to check the status
    ) {
      const message: MessageData = {
        title: i18n.t('notifications.server-busy'),
        description: i18n.t('notifications.we-are-currently-updating-the-data-from-the-provider-please-try-'),
        type: MessageStates.WARNING,
      };
      yield put(turnMessageOn(message));
      yield put(fetchRunDataFailure());
      if (!navigateToReport) {
        yield put(push(routes.main));
      }
      //} else if (statusCheckResponse.data.status === DataStatus.IDLE) {
    } else {
      const response: GetRunDataResponse = yield call(
        getRunData,
        vatRunRequestData
      );

      err = checkResponse(response?.responseMessage);
      if (err) throw err;

      const vatRunData: VatRunData = response.data;
      yield put(updateMappingData(undefined));
      yield put(fetchRunDataSuccess(vatRunData));
      if (
        navigateToReport &&
        sessionStorage.getItem('last-created-report')
      ) {
        const search = buildGroupReturnContextSearch(groupContext);
        yield put(push(`${reportRoute ?? routes.vat.report}${search}`));
      }
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchRunDataFailure());
    if (!action.payload.navigateToReport) {
      yield put(push(routes.main));
    }
  }
}

export function* watchFetchRunDataSaga() {
  let task;
  while (true) {
    const action: FetchRunDataRequestAction = yield take(FETCH_RUN_DATA_REQUEST);
    if (task) {
      yield cancel(task);
    }
    task = yield fork(fetchRunDataSaga, action);

    const result = yield race({
      completed: task,
      cancelled: take(CANCEL_VAT_SAGA),
    });

    if (result.cancelled) {
      yield cancel(task);
    }
  }
}
